module.exports = {
	"entityMap": {
		"0": {
			"type": "button",
			"mutability": "IMMUTABLE",
			"data": {
				"text": "Hello"
			}
		}
	},
	"blocks": [
		{
			"key": "3s0b9",
			"text": "",
			"type": "unstyled",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": []
		},
		{
			"key": "9c9j",
			"text": " ",
			"type": "atomic",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": [
				{
					"offset": 0,
					"length": 1,
					"key": 0
				}
			]
		},
		{
			"key": "6jkbd",
			"text": "",
			"type": "unstyled",
			"depth": 0,
			"inlineStyleRanges": [],
			"entityRanges": []
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/content.json
// module id = 257
// module chunks = 0